import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessage = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.5 2H4.5C3.4 2 2.5 2.9 2.5 4V22L6.5 18H20.5C21.6 18 22.5 17.1 22.5 16V4C22.5 2.9 21.6 2 20.5 2ZM6.5 16L4.5 18V4H20.5V16H6.5ZM9.5 9H7.5V11H9.5V9ZM11.5 9H13.5V11H11.5V9ZM17.5 9H15.5V11H17.5V9Z",
			fill: "#fad504"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0",
			"mask-type": "alpha",
			maskUnits: "userSpaceOnUse",
			x: 2,
			y: 2,
			width: 21,
			height: 24,
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M20.5 2H4.5C3.4 2 2.5 2.9 2.5 4V22L6.5 18H20.5C21.6 18 22.5 17.1 22.5 16V4C22.5 2.9 21.6 2 20.5 2ZM6.5 16L4.5 18V4H20.5V16H6.5ZM9.5 9H7.5V11H9.5V9ZM11.5 9H13.5V11H11.5V9ZM17.5 9H15.5V11H17.5V9Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", { mask: "url(#mask0)" })
	]
});
const ForwardRef = forwardRef(SvgMessage);
export default ForwardRef;
